

document.addEventListener("DOMContentLoaded", function () {

    // Global Variables
    let customCartDrawerOpenCloseBtn = document.querySelector("#custom-cart-drawer-open-close-btn");
    let customCartDrawer = document.querySelector("custom-cart-drawer");
    let customCartDrawerInner = customCartDrawer.querySelector(".custom-drawer-inner");
    let customCartDrawerCloseBtnInner = document.querySelector(".custom-drawer-close-btn");
    var customUpsellInsuranceCheckbox = document.querySelector(".customUpsellInsuranceCheckbox");
    let customUpsellInsuranceAtc = document.querySelector(".customInsuranceAtc");

  
    // init - Preparing the drawer opening button
    (function () {
        if (customCartDrawerOpenCloseBtn) {
            customCartDrawerOpenCloseBtn.style.pointerEvents = "auto";
            addInsurance();

            // Open Button is ready now, you can invoke openCustomCartDrawer() and closeCustomCartDrawer()
            updateCustomCartCount();
            openCustomCartDrawer();
            closeCustomCartDrawer();
            upsellSelectEventListener();

            // Add To Cart btns are ready
            addToCartBtnEventListener();
            removeItemEventListener();
            updateItemEventListener();
            checkInsuranceAndWarranty();
        }
    })();

    // open drawer
    function openCustomCartDrawer() {
        if (customCartDrawerOpenCloseBtn) {
            customCartDrawerOpenCloseBtn.addEventListener("click", () => {
                customCartDrawerInner.style.transform = "none";
                customCartDrawer.style.visibility = "visible";
                document.body.style.overflow = "hidden";
            });
        }
    }

    // close drawer
    function closeCustomCartDrawer() {
        // By screen click
        document.addEventListener("click", (e) => {
            if (customCartDrawer.contains(e.target)) {
                if (
                    !customCartDrawerInner.contains(e.target) &&
                    e.target !== customCartDrawerCloseBtnInner
                ) {
                    closeDrawer();
                }
            }
        });

        function closeDrawer() {
            customCartDrawerInner.style.transform = "translate(100%)";
            customCartDrawer.style.visibility = "hidden";
            document.body.style.overflow = "visible";
            // console.log("close");
        }
    }

    // add event
    function addToCartBtnEventListener(atcBtns) {

        // page atc buttons 
        if (atcBtns === undefined) {
            var allCustomAddToCartBtns = document.querySelectorAll(".atcBtnDrawer");
            if (allCustomAddToCartBtns) {
                allCustomAddToCartBtns.forEach((item) => {
                    item.addEventListener("click", (e) => {
                        item.style.pointerEvents = "none";
                        let catchAtcBtn = e.target.closest(".atcBtnDrawer")
                        addCustomCartItem(catchAtcBtn.dataset.atc, item);
                    });
                });
            }

        } else {
            // drawer atc buttons
            if (atcBtns) {
                // console.log("atcBtns -->", atcBtns);
                atcBtns.forEach((item) => {
                    item.addEventListener("click", (e) => {
                        item.style.pointerEvents = "none";
                        addCustomCartItem(e.target.dataset.atc, item);
                    });
                });
            }
        }

    }

    // delete event
    function removeItemEventListener() {
        let allCustomItemCards =
            customCartDrawerInner.querySelectorAll(".custom-cart-item");
        if (allCustomItemCards) {
            // console.log("removeItemEventListener allCustomItemCards ->", allCustomItemCards);
            allCustomItemCards.forEach((item) => {
                item
                    .querySelector(".cart-item-remove-btn")
                    .addEventListener("click", (e) => {
                        e.preventDefault();

                        item.style.pointerEvents = "none";
                        item.querySelector(".price-remove-loader").innerHTML = `<span style="width: 14px; height: 14px;" class="minus-plus-loader"></span>`;
                        var itemID = e.target.closest(".cart-item-remove-btn").dataset
                            .variantid;
                        // console.log("itemID ->", itemID);
                        removeCustomCartItem(itemID, item);
                    });
            });
        }
    }

    // update event
    function updateItemEventListener() {
        let allCustomItemCards =
            customCartDrawerInner.querySelectorAll(".custom-cart-item");
        if (allCustomItemCards) {
            // console.log("updateItemEventListener allCustomItemCards ->", allCustomItemCards);
            allCustomItemCards.forEach((item) => {
                if (item.querySelector(".minus-plus-btns")) {
                    // minus
                    item.querySelector(".minus").addEventListener("click", (e) => {
                        e.preventDefault();

                        let itemKey = e.target.closest(".custom-cart-item").dataset.itemkey;
                        let currentQTY = Number(e.target.closest(".minus").dataset.itemqty);
                        let newQTY = currentQTY - 1;
                        updateCustomCartItem(itemKey, newQTY, item, e.target);
                    });

                    // plus
                    item.querySelector(".plus").addEventListener("click", (e) => {
                        e.preventDefault();

                        let itemKey = e.target.closest(".custom-cart-item").dataset.itemkey;
                        let currentQTY = Number(e.target.closest(".plus").dataset.itemqty);
                        let newQTY = currentQTY + 1;
                        updateCustomCartItem(itemKey, newQTY, item, e.target);
                    });
                }

            });
        }
    }

    // add
    function addCustomCartItem(variantID, item) {
      console.log("item",item)

        let findUpsellProductCard = item.closest(".upsell-product-item-cart")
        if(findUpsellProductCard) {
          findUpsellProductCard.querySelector(".atcBtnDrawer").innerHTML = `<span class="warranty-loader"></span>`;
          findUpsellProductCard.querySelector(".atcBtnDrawer").style.pointerEvents = "none";
        }

      
        let formData = {
            items: [
                {
                    id: variantID,
                    quantity: 1,
                    properties: {
                      Selection: `${item.getAttribute("data-selection")}`,
                    }
                }
            ]
        };
        fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
        })
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                if (data) {
                    if (!item.classList.contains("upsellAtcBtnDrawer")) {
                        addInsuranceAfterCWUnit(); // first unit insurance
                    }

                    updateCustomCartDrawer();
                    setTimeout(() => {
                        updateAfterOpen();
                      
                        if(findUpsellProductCard) {
                          // upsell warranty
                          if(item.classList.contains("warrantyAtc")) {
                            setTimeout(() => {  
                              findUpsellProductCard.querySelector(".atcBtnDrawer").style.pointerEvents = "auto";
                            }, 3000)

                          // upsell others
                          } else {
                            item.innerHTML = "ADD";
                            item.style.pointerEvents = "auto";
                          }
                          
                        } else {
                          item.style.pointerEvents = "auto";
                        }
                      
// ERSEN                      
                        // if (!item.classList.contains("upsellAtcBtnDrawer")) {
                        //   item.innerHTML = "Buy Now";
                        // } 
// ERSEN  
                        
                      
                    }, 200);
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }

    // delete
    function removeCustomCartItem(variantID, item) {
        fetch("/cart/change.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                id: variantID,
                quantity: 0,
            }),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data) {
                    updateCustomCartDrawer();
                    setTimeout(() => {
                        // updateAfterOpen();
                        item.style.pointerEvents = "auto";
                    }, 200);
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }

    // update
    function updateCustomCartItem(itemKey, newQTY, item, eTarget) {
        eTarget.closest(".minus-plus-btn").innerHTML = `<span class="minus-plus-loader"></span>`;
        item.style.pointerEvents = "none";
      
        fetch("/cart/update.js", {
            method: "post",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ updates: { [itemKey]: newQTY } }),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data) {
                    updateCustomCartDrawer();
                    setTimeout(() => {
                        item.style.pointerEvents = "auto";
                    }, 200);
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }

    // upsell select event
    function upsellSelectEventListener() {
        var customUpsellProducts = document.querySelector(".custom-drawer-upsell-products");
        if (customUpsellProducts) {
            var customUpsellProduct = customUpsellProducts.querySelectorAll(".upsell-product-item-cart");
            if (customUpsellProduct) {
                customUpsellProduct.forEach(item => {
                    var upsellProductAddToCart = item.querySelector(".atcBtnDrawer");
                    var upsellProductWithVariants = item.querySelector("#upsell_variant_select");
                    var upsell_item_price = item.querySelector(".upsell_item_price");

                    // Upsell product has more than one variant
                    if (upsellProductWithVariants) {
                        upsellProductWithVariants.addEventListener("change", e => {
                            const selectedOption = e.target.options[e.target.selectedIndex];

                            upsell_item_price.innerHTML = selectedOption.dataset.variantprice;
                            upsellProductAddToCart.dataset.selection = selectedOption.dataset.selection;
                            // item.dataset.variantimage = selectedOption.dataset.variantimage;
                            upsellProductAddToCart.dataset.atc = e.target.value;

                        })
                    }

                })
            }
        }
    }

    // check insurance and warranty
    function checkInsuranceAndWarranty() {
        var customUpsellInsuranceCheckbox = document.querySelector(".customUpsellInsuranceCheckbox");
        var customUpsellWarraantyCard = document.querySelector(".item_cart_id-6783008538714");
        fetch(window.Shopify.routes.root + 'cart.js')
            .then(response => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.json();
            })
            .then(data => {
                const foundInsurance = data.items.some(item => item.product_id == 6625923006554);
                const foundWarranty = data.items.some(item => item.product_id == 6783008538714);

                if (customUpsellInsuranceCheckbox) {
                    if (foundInsurance) {
                        // console.log("sepette insurance var");
                        customUpsellInsuranceCheckbox.checked = true;
                        updateInsuranceQty(); // insurance birden fazlaysa 1 e düşür
                    } else {
                        // console.log("sepette insurance yok");
                        customUpsellInsuranceCheckbox.checked = false;
                    }
                }

                if (customUpsellWarraantyCard) {
                    if (foundWarranty) {
                        // console.log("sepette warranty var.");
                        customUpsellWarraantyCard.querySelector(".atcBtnDrawer").disabled = true;
                        // customUpsellWarraantyCard.querySelector(".atcBtnDrawer").innerHTML = "ADDED";
                        customUpsellWarraantyCard.querySelector(".atcBtnDrawer").innerHTML = `
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check"><polyline points="20 6 9 17 4 12"/></svg>
            `;
                        customUpsellWarraantyCard.querySelector(".atcBtnDrawer").style.backgroundColor = "#ffcc33";
                        customUpsellWarraantyCard.querySelector("#upsell_variant_select").style.opacity = "0";
                        customUpsellWarraantyCard.style.pointerEvents = "none";
                    } else {
                        // console.log("sepette warranty yok.");
                        customUpsellWarraantyCard.querySelector(".atcBtnDrawer").disabled = false;
                        customUpsellWarraantyCard.querySelector(".atcBtnDrawer").innerHTML = "ADD";
                        customUpsellWarraantyCard.querySelector(".atcBtnDrawer").style.backgroundColor = "#000";
                        customUpsellWarraantyCard.querySelector("#upsell_variant_select").style.opacity = "1";
                        customUpsellWarraantyCard.style.pointerEvents = "auto";
                    }
                }

            })
            .catch(error => console.error('Error:', error));
    }

    // add insurance 
    function addInsurance(atcBtns) {
        if (atcBtns === undefined) {
            if (customUpsellInsuranceAtc) {
                console.log("customUpsellInsuranceAtc -->", customUpsellInsuranceAtc);
                customUpsellInsuranceAtc.addEventListener("click", e => {
                    // console.log("e.target.dataset.atc", e.target.dataset.atc);
                    // customUpsellInsuranceAtc.style.pointerEvents = "none";
                    customUpsellInsuranceAtc.closest(".shipping-input-part").style.pointerEvents = "none";



                    // ------------
                    fetch(window.Shopify.routes.root + 'cart.js')
                        .then(response => {
                            if (!response.ok) throw new Error('Network response was not ok');
                            return response.json();
                        })
                        .then(data => {
                            const foundInsurance = data.items.some(item => item.product_id == 6625923006554);
                            if (customUpsellInsuranceCheckbox) {
                                if (foundInsurance) {
                                    // console.log("sepette insurance var");

                                    // ----
                                    fetch("/cart/change.js", {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json",
                                        },
                                        body: JSON.stringify({
                                            id: e.target.dataset.atc,
                                            quantity: 0,
                                        }),
                                    })
                                        .then((response) => response.json())
                                        .then((data) => {
                                            if (data) {
                                                updateCustomCartDrawer();
                                                setTimeout(() => {
                                                    customUpsellInsuranceAtc.closest(".shipping-input-part").style.pointerEvents = "auto";
                                                }, 1800);
                                            }
                                        })
                                        .catch((error) => {
                                            console.error("Error:", error);
                                        });
                                    // ----

                                } else {
                                    // console.log("sepette insurance yok");

                                    // -------
                                    let formData = {
                                        items: [
                                            {
                                                id: e.target.dataset.atc,
                                                quantity: 1,
                                            },
                                        ],
                                    };
                                    fetch(window.Shopify.routes.root + "cart/add.js", {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json",
                                        },
                                        body: JSON.stringify(formData),
                                    })
                                        .then((response) => {
                                            return response.json();
                                        })
                                        .then((data) => {
                                            if (data) {
                                                updateCustomCartDrawer();
                                                setTimeout(() => {
                                                    customUpsellInsuranceAtc.closest(".shipping-input-part").style.pointerEvents = "auto";
                                                }, 1800);
                                            }
                                        })
                                        .catch((error) => {
                                            console.error("Error:", error);
                                        });
                                    // -------

                                }
                            }

                        })
                        .catch(error => console.error('Error:', error));
                    // ------------

                })
            }
        } else {
            if (atcBtns) {
                // console.log("atcBtns -->", atcBtns);
                atcBtns.addEventListener("click", e => {
                    // console.log("e.target.dataset.atc", e.target.dataset.atc);
                    // customUpsellInsuranceAtc.style.pointerEvents = "none";
                    atcBtns.closest(".shipping-input-part").style.pointerEvents = "none";



                    // ------------
                    fetch(window.Shopify.routes.root + 'cart.js')
                        .then(response => {
                            if (!response.ok) throw new Error('Network response was not ok');
                            return response.json();
                        })
                        .then(data => {
                            const foundInsurance = data.items.some(item => item.product_id == 6625923006554);
                            if (atcBtns) {
                                if (foundInsurance) {
                                    // console.log("sepette insurance var");

                                    // ----
                                    fetch("/cart/change.js", {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json",
                                        },
                                        body: JSON.stringify({
                                            id: e.target.dataset.atc,
                                            quantity: 0,
                                        }),
                                    })
                                        .then((response) => response.json())
                                        .then((data) => {
                                            if (data) {
                                                updateCustomCartDrawer();
                                                setTimeout(() => {
                                                    atcBtns.closest(".shipping-input-part").style.pointerEvents = "auto";
                                                }, 1800);
                                            }
                                        })
                                        .catch((error) => {
                                            console.error("Error:", error);
                                        });
                                    // ----

                                } else {
                                    // console.log("sepette insurance yok");

                                    // -------
                                    let formData = {
                                        items: [
                                            {
                                                id: e.target.dataset.atc,
                                                quantity: 1,
                                            },
                                        ],
                                    };
                                    fetch(window.Shopify.routes.root + "cart/add.js", {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json",
                                        },
                                        body: JSON.stringify(formData),
                                    })
                                        .then((response) => {
                                            return response.json();
                                        })
                                        .then((data) => {
                                            if (data) {
                                                updateCustomCartDrawer();
                                                setTimeout(() => {
                                                    atcBtns.closest(".shipping-input-part").style.pointerEvents = "auto";
                                                }, 1800);
                                            }
                                        })
                                        .catch((error) => {
                                            console.error("Error:", error);
                                        });
                                    // -------

                                }
                            }

                        })
                        .catch(error => console.error('Error:', error));
                    // ------------

                })

            }
        }
    }

    // add insurance after cw unit once
    function addInsuranceAfterCWUnit() {
        fetch(window.Shopify.routes.root + 'cart.js')
            .then(response => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.json();
            })
            .then(data => {
                const foundInsurance = data.items.some(item => item.product_id == 6625923006554);

                if (!foundInsurance) {
                    // console.log("addInsuranceAfterCWUnit first insurance yok");
                    // -------
                    let formData = {
                        items: [
                            {
                                id: 39537614979162,
                                quantity: 1,
                            },
                        ],
                    };
                    fetch(window.Shopify.routes.root + "cart/add.js", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(formData),
                    })
                        .then((response) => {
                            return response.json();
                        })
                        .then((data) => {
                            if (data) {
                                updateInsuranceQty();
                            }
                        })
                        .then(() => {
                            // console.log("çalıştı --->");
                            updateCustomCartDrawer();
                        })
                        .catch((error) => {
                            console.error("Error:", error);
                        });
                    // -------
                }

            })
            .catch(error => console.error('Error:', error));
    }

    // update insurance qty
    function updateInsuranceQty() {
        let updates = {
            39537614979162: 1
        };
        fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ updates })
        })
            .then(response => {
                return response.json();
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    // open drawer after add to cart
    function updateAfterOpen() {
        customCartDrawerInner.style.transform = "none";
        customCartDrawer.style.visibility = "visible";
        document.body.style.overflow = "hidden";
        // console.log("open");
    }

    // update drawer
    async function updateCustomCartDrawer() {
        const res = await fetch("/?section_id=custom-cart-drawer");
        const text = await res.text();

        const html = document.createElement("div");
        html.innerHTML = text;

        // update header shop icon count
        updateCustomCartCount();

        // update all drawer content
        if (html.querySelector(".custom-cart-empty")) {
            const customDrawerCartInnerHTMLNEWCONTENT = html.querySelector(".custom-drawer-inner").innerHTML;
            const customDrawerCartInnerHTMLOLDCONTENT = document.querySelector(".custom-drawer-inner").innerHTML = customDrawerCartInnerHTMLNEWCONTENT;
            // console.log("drawer boş -->");

        } else {
            const customDrawerCartItemsHTMLNEWCONTENT = html.querySelector(".custom-drawer-cart-items").innerHTML;
            const customDrawerCartItemsHTMLOLDCONTENT = document.querySelector(".custom-drawer-cart-items");

            if (customDrawerCartItemsHTMLOLDCONTENT) {
                customDrawerCartItemsHTMLOLDCONTENT.innerHTML = customDrawerCartItemsHTMLNEWCONTENT;
                const customDrawerCheckoutBtnHTMLNEWCONTENT = html.querySelector(".custom-drawer-checkout-btn").innerHTML;
                const customDrawerCheckoutBtnHTMLOLDCONTENT = document.querySelector(".custom-drawer-checkout-btn").innerHTML = customDrawerCheckoutBtnHTMLNEWCONTENT;
                // console.log("drawer dolu normal -->");
                // checkInsuranceAndWarranty(customUpsellInsuranceCheckbox);
                checkInsuranceAndWarranty();

            } else {
                const customDrawerCartInnerHTMLNEWCONTENT = html.querySelector(".custom-drawer-inner").innerHTML;
                const customDrawerCartInnerHTMLOLDCONTENT = document.querySelector(".custom-drawer-inner").innerHTML = customDrawerCartInnerHTMLNEWCONTENT;
                // console.log("drawer boş ilk -->");

                // Since we cannot capture the ATC buttons inside the drawer when the drawer is empty, we capture it only once when it is full.
                var customUpsellAllAtcBtns = document.querySelectorAll(".custom-drawer-inner .atcBtnDrawer");
                addToCartBtnEventListener(customUpsellAllAtcBtns);

                // After the drawer is filled, assign a select event once.
                upsellSelectEventListener();

                var customUpsellInsuranceFillBtn = document.querySelector(".customInsuranceAtc");
                addInsurance(customUpsellInsuranceFillBtn);

                // var customUpsellInsuranceFillCheckbox = document.querySelector(".customUpsellInsuranceCheckbox");
                // console.log("customUpsellInsuranceFillCheckbox -->", customUpsellInsuranceFillCheckbox);
                // checkInsuranceAndWarranty(customUpsellInsuranceFillCheckbox);
                checkInsuranceAndWarranty();

            }

        }


        removeItemEventListener();
        updateItemEventListener();


        // console.log("drawer updated -->");

    }

    // update header shop icon count
    function updateCustomCartCount() {
        let customCartDraweropenCloseCount = document.querySelector(".custom-cart-drawer-open-close-count");
        if (customCartDraweropenCloseCount) {
            fetch(`/cart.js`)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.json();
                })
                .then(data => {
                    if (data.item_count > 0) {
                        customCartDraweropenCloseCount.style.opacity = "1";
                        customCartDraweropenCloseCount.innerHTML = data.item_count;
                    } else {
                        customCartDraweropenCloseCount.style.opacity = "0";
                    }
                })
                .catch(error => {
                    console.error(error);
                });
        }
    }

    // DOM end ----->
});
